import { render, staticRenderFns } from "./CardItemBase.vue?vue&type=template&id=556a7a7d&scoped=true&"
import script from "./CardItemBase.vue?vue&type=script&lang=js&"
export * from "./CardItemBase.vue?vue&type=script&lang=js&"
import style0 from "./CardItemBase.vue?vue&type=style&index=0&id=556a7a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a7a7d",
  null
  
)

export default component.exports